// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"faa48e3e","455":"11d38f28","977":"24149f6d"}[chunkId] + ".chunk.js";
};